import React, { useEffect, useMemo, useState } from 'react';

const InstallPrompt = () => {
  const [promptEvent, setPromptEvent] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const isStandalone = useMemo(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  }, []);

  const [isHidden, setIsHidden] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('installPromptHidden') === 'true';
    }
    return false;
  });

  useEffect(() => {
    const handleBeforeInstall = (event) => {
      event.preventDefault();
      setPromptEvent(event);
    };
    const handleInstalled = () => {
      setPromptEvent(null);
      setIsInstalled(true);
    };
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    window.addEventListener('appinstalled', handleInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
      window.removeEventListener('appinstalled', handleInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!promptEvent) return;
    promptEvent.prompt();
    await promptEvent.userChoice;
    setPromptEvent(null);
  };

  const handleHide = () => {
    setIsHidden(true);
    localStorage.setItem('installPromptHidden', 'true');
  };

  if (isStandalone || isInstalled || !promptEvent || isHidden) return null;

  return (
    <div className="install-banner" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', background: '#e6fffa', borderBottom: '1px solid #b2f5ea' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span>Install the app for a faster, native-like experience.</span>
        <button onClick={handleInstall} style={{ padding: '5px 15px', background: '#319795', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Install</button>
      </div>
      <button onClick={handleHide} style={{ background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', padding: '0 5px' }}>&times;</button>
    </div>
  );
};

export default InstallPrompt;
